export default "__VITE_ASSET__B9UFa9$___"